<template>
   <div class="dashboard-wrap">
        <h1 class="dashboard-title">Уведомления</h1>
        <div class="lazy-loader relative" v-if="loading">
            <div class="loader lg"></div>
        </div>
        <div v-else>
            <template v-for="(notice, date) in notifications.notifications" :key="notice">
                <h1 class="notification-date">{{ date }}</h1>
                <div class="notification-wrap" v-for="item in notice" :key="item">
                    <b class="notification-title">
                        <span>{{ item.name }}</span>
                        <span class="notification-time" :class="!item.view && 'active'">{{ item.time }}</span>
                    </b>
                    <p class="notification-text">{{ item.message }}</p>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    created() {
        const self = this
        setTimeout(() => {
            self.$store.dispatch('passedNotifications')
        }, 2000)
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        notifications() {
            return this.$store.getters.notifications
        }
    }
}
</script>